import { render, staticRenderFns } from "./installation-status-select.vue?vue&type=template&id=96733944"
import script from "./installation-status-select.vue?vue&type=script&lang=js"
export * from "./installation-status-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96733944')) {
      api.createRecord('96733944', component.options)
    } else {
      api.reload('96733944', component.options)
    }
    module.hot.accept("./installation-status-select.vue?vue&type=template&id=96733944", function () {
      api.rerender('96733944', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/modules/installation/components/installation-status-select.vue"
export default component.exports